import React from 'react';
import {
  Cushion,
  FlexContainer,
  ShimmerIcon,
  ShimmerAvatar,
  ShimmerTypography,
} from '@pitchero/react-ui';

const AvailabilityBarLoadingState = () => (
  <Cushion all="small">
    <FlexContainer flexDirection="row" justifyContent="space-between" alignItems="center">
      <ShimmerAvatar size={40} />
      <ShimmerTypography preset="body--large" width="50%" />
      <ShimmerIcon size={28} />
    </FlexContainer>
  </Cushion>
);

export default AvailabilityBarLoadingState;
